const popupModule =
    popupModule || (()=>{
        const popupClass = 'popup';

        const getCloseButton = (popup)=> popup.querySelector(`.${popupClass}__close-button`)
        const showPopup = (popup)=> {
            popup.classList.remove('d-none')
            popup.classList.add('state-appear')
        }
        const getLocalStorageName = (popup)=> `modal-${popup.dataset.id}`
        const initPopup = (popup)=>{
            const closeButton = getCloseButton(popup);
            if (!!closeButton){
                closeButton.addEventListener('click', ()=>{
                    popup.classList.remove('state-appear')
                    popup.classList.add('state-leave')
                    localStorage.setItem(getLocalStorageName(popup), 1);
                })
            }

            const watchTheAnimationEnd = ()=>{
                if(popup.classList.contains('state-leave')) {
                  popup.classList.remove('state-leave');
                  popup.classList.add('d-none')
                }
              }
              popup.addEventListener('webkitAnimationEnd', watchTheAnimationEnd)
              popup.addEventListener('oanimationend', watchTheAnimationEnd)
              popup.addEventListener('msAnimationEnd', watchTheAnimationEnd)
              popup.addEventListener('animationend', watchTheAnimationEnd)

            if (popup.dataset.p){
                var percent = +popup.dataset.p / 100;
                const checkScrollPercent = ()=>{
                    if (popup.classList.contains('d-none')
                        || ((window.visualViewport.height + window.scrollY) / document.body.clientHeight) < percent){
                        //console.debug((window.visualViewport.height + window.scrollY) / document.body.clientHeight, percent)
                        return;
                    }

                    showPopup(popup)
                }
                window.addEventListener('scroll', checkScrollPercent)
                checkScrollPercent()
            }
            else if (popup.dataset.t){
                var delayInSeconds = +popup.dataset.t * 1000;
                setTimeout(()=>{
                    showPopup(popup)
                }, delayInSeconds)
            }
            else{
                showPopup(popup);
            }
        }
        
        const init = ()=>{
            var popups = [...document.querySelectorAll('.popup')]
                .filter((x)=>{
                    return !localStorage.getItem(getLocalStorageName(x))
                })
            if (popups.length){
                initPopup(popups[0])
            }
        }

        return {
            init
        }
    })()

window.addEventListener("DOMContentLoaded", popupModule.init)